import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
    Box,
    Typography,
    Button,
    Card,
    CardContent,
    Stack,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import "./css/msg.css";

const Msg = () => {
    const location = useLocation();
    const navigate = useNavigate();

    // Support both React navigate state & Stripe URL params
    const queryParams = new URLSearchParams(location.search);
    const queryStatus = queryParams.get("status");
    const queryMsg = queryParams.get("msg");

    const stateStatus = location.state?.status;
    const stateMsg = location.state?.msg;

    const status = stateStatus || queryStatus;
    const msg = stateMsg || queryMsg;

    // If no data found, show fallback message
    if (!status) {
        return (
            <Box className="msg-container">
                <Card className="msg-card">
                    <CardContent>
                        <Typography variant="h5" color="text.secondary">
                            No message to display.
                        </Typography>
                        <Button
                            variant="contained"
                            color="error"
                            sx={{ mt: 3 }}
                            onClick={() => navigate("/")}
                        >
                            Back to Home
                        </Button>
                    </CardContent>
                </Card>
            </Box>
        );
    }

    const isSuccess = status === "success";

    return (
        <Box className="msg-container">
            <Card className={`msg-card ${isSuccess ? "success" : "error"}`}>
                <CardContent>
                    <Stack
                        spacing={2}
                        alignItems="center"
                        justifyContent="center"
                        textAlign="center"
                    >
                        {isSuccess ? (
                            <CheckCircleOutlineIcon className="msg-icon success" />
                        ) : (
                            <ErrorOutlineIcon className="msg-icon error" />
                        )}

                        <Typography variant="h4" fontWeight={600}>
                            {isSuccess ? "Order Successful!" : "Order Failed"}
                        </Typography>

                        <Typography variant="body1" color="text.secondary">
                            {decodeURIComponent(msg)}
                        </Typography>

                        <Button
                            variant="contained"
                            color={isSuccess ? "success" : "error"}
                            sx={{ mt: 3 }}
                            onClick={() => navigate("/")}
                        >
                            {isSuccess
                                ? "Continue Shopping"
                                : "Try Again / Back to Home"}
                        </Button>
                    </Stack>
                </CardContent>
            </Card>
        </Box>
    );
};

export default Msg;